import { Component, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { EventEmitter } from "events";
import { OnLineValidationService } from "src/app/services/on-line-validation/on-line-validation.service";

@Component({
  selector: "app-transaction-reference",
  templateUrl: "./transaction-reference.component.html",
  styleUrls: ["./transaction-reference.component.css"],
})
export class TransactionReferenceComponent implements OnInit {
  @Input() transactionReferenceMessage: string;
  @Input() transactionReferenceNumber: string;
  @Input() medicalAppointmentId: number;
  @Input() enabledEdition: boolean;
  @Output() transactionReferenceChanged: EventEmitter = new EventEmitter();

  loading: boolean = false;
  readonly: boolean = true;

  control: FormControl = new FormControl();

  constructor(private onLineValidationService: OnLineValidationService) {}

  ngOnInit() {
    this.control.setValue(this.transactionReferenceNumber);
    this.control.disable();
  }

  edit() {
    this.readonly = false;
    this.control.enable();
  }

  async done() {
    if (this.control.value !== "") {
      try {
        this.loading = true;
        await this.onLineValidationService.changeValidationReferenceNumber(
          this.medicalAppointmentId,
          this.control.value
        );
        this.readonly = true;
        this.control.disable();
        this.transactionReferenceChanged.emit(this.control.value);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }

  cancel() {
    this.readonly = true;
    this.control.disable();
  }
}
